module.exports = __webpack_public_path__ + "media/images/icons/icn_019-d948a01e09dc00105da70b9c9229ef18.svg";